// Resolve a storage_path (returned by the backend) to a fully-qualified URL.
// Backend exposes objects via GET /api/files/{path}.

const API = process.env.REACT_APP_BACKEND_URL;

export const resolveStorageUrl = (storagePath) => {
  if (!storagePath) return '';
  if (storagePath.startsWith('http://') || storagePath.startsWith('https://')) return storagePath;
  return `${API}/api/files/${storagePath}`;
};
